module.exports = __webpack_public_path__ + "images/organization/empty-board.286f8fc83e01c93ed27e.svg";